<template>
  <div class="kye-date-picker2_time-select" :class="{ 'has-seconds': showSeconds }">
    <div class="time-select_input">
      <el-input
        class="time-select_inputdom"
        ref="input"
        :value="visibleTime"
        @input="(val) => (userInputTime = val)"
        @change="handleKeydown"
        />
    </div>
    <div
      class="kye-date-picker2_timecontent el-time-panel__content"
      :class="{ 'has-seconds': showSeconds }">
      <TimeSpinner
        ref="spinner"
        class="kye-date-picker2_timeSpinner"
        :date="date"
        :show-seconds="showSeconds"
        :am-pm-mode="amPmMode"
        @change="handleChange">
      </TimeSpinner>
    </div>
  </div>
</template>

<script>
import TimeSpinner from './time-spinner'
import {
  clearMilliseconds,
  formatDate,
  timeWithinRange,
  // parseDate,
  // modifyDate,
  extractTimeFormat,
  limitTimeRange,
  parseTimeDate
} from '../utils'

export default {
  components: {
    TimeSpinner
  },
  data() {
    return {
      userInputTime: null,
      timePickerVisible: false,
      date: new Date(),
      format: 'HH:mm',
      selectableRange: [],
      defaultValue: null,
      value: null,
    }
  },
  mounted() {
    this.$emit('mounted')
  },
  watch: {
    value(newVal) {
      this.setValue(newVal)
    }
  },
  computed: {
    visibleTime() {
      if (this.userInputTime !== null) {
        return this.userInputTime
      } else {
        return formatDate(this.value || this.defaultValue, this.timeFormat)
      }
    },
    showSeconds() {
      return (this.format || '').indexOf('ss') !== -1
    },
    amPmMode() {
      if ((this.format || '').indexOf('A') !== -1) return 'A'
      if ((this.format || '').indexOf('a') !== -1) return 'a'
      return ''
    },
    timeFormat() {
      if (this.format) {
        return extractTimeFormat(this.format)
      } else {
        return 'HH:mm'
      }
    },
  },
  methods: {
    setValue(newVal) {
      let date
      if (newVal instanceof Date) {
        date = limitTimeRange(newVal, this.selectableRange, this.format)
      } else if (!newVal) {
        date = this.defaultValue ? new Date(this.defaultValue) : new Date()
      }
      this.date = date
    },
    isValidValue(date) {
      return timeWithinRange(date, this.selectableRange, this.format)
    },
    handleChange(date) {
      this.date = clearMilliseconds(date)
      if (this.isValidValue(this.date)) {
        this.$emit('pick', this.date, true)
        this.value = this.date
      }
    },
    adjustSpinners() {
      return this.$refs.spinner.adjustSpinners()
    },
    handleKeydown () {
      const { date, timeValue } = parseTimeDate(this.visibleTime, this.format, this.date) || {}
      if (date) {
        this.date = date
        this.userInputTime = timeValue
      } else {
        this.userInputTime = ''
      }
      this.$nextTick(() => {
        this.adjustSpinners()
      })
      return false
    }
  }
}
</script>

<style lang="scss">
.kye-date-picker2{
  &_time-select{
    width: 152px;
    height: 315px;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    flex-direction: column;
    padding: 12px 16px 6px 12px;
    .time-select_input{
      display:flex;
      justify-content: center;
      width: 100%;
      margin-bottom: 10px;
      height: 28px;
      &dom{
        width: 120px;
      }
    }
  }
  &_timecontent{
    width: 100%;
    flex: 1;
    .el-time-spinner__wrapper{
      height: 265px;
      max-height: none;
    }
    .el-time-spinner__list::after, .el-time-spinner__list::before{
      height: 120px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-date-picker2/src/basic/time-select.vue